import { ArrowLeft, ArrowRight } from 'react-feather';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { Back, Pinned } from '../../constants';
import { routes } from '../../routers/routes';
import { dynamicImage } from '../../utils';
import LogoWrapper from './widgets/LogoWrapper';
import { useAppDispatch, useAppSelector } from '../../reduxToolkit/hooks';
import ConfigDB from '../../config/Theme';
import {
  scrollToLeft,
  scrollToRight,
} from '../../reduxToolkit/reducers/layout/themeCustomizerSlice';
import MenuList from './widgets/menuList';
import { Image } from '../../coreComponents/Image';
import { UserRole } from '../../types/Forms';
import { useEffect, useState } from 'react';
import { getStudentCourses } from '../../services/api';
import { getMenuList } from '../../data/layout/SidebarMenuList';
import { MenuItem } from '../../types/Layout';
import { StudentCourse } from '../../types/Courses';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
const Sidebar = () => {
  const { t } = useTranslation();
  const [menuList, setMenuList] = useState<MenuItem[]>([]);
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const { margin, sideBarToggle } = useAppSelector((state) => state.themeCustomizer);
  const sidebarIconType = useAppSelector((state) => state.themeCustomizer.sideBarIconType);
  const sideBarIcon = sidebarIconType || ConfigDB.settings.sidebar.iconType;
  const dispatch = useAppDispatch();
  const { role, id } = useAppSelector((state) => state.auth);
  useEffect(() => {
    if (!role) {
      setMenuList([]);
      return;
    }
    if (role !== UserRole.STUDENT && role) {
      const menuItems = getMenuList(role, t) || [];
      setMenuList(menuItems); // assuming MenuItem has a 'title' property
      return;
    }
    const getStudentCoursesRoutes = async (): Promise<void> => {
      const courses: StudentCourse[] = await getStudentCourses(id);
      if (courses && courses.length > 0) {
        const menuItems = courses.map((course) => ({
          title: course.name, // Use the correct property for course name
          type: 'link',
          url: routes.Courses.LessonDetailsPage.replace(':id', String(course.courseId)).replace(
            ':lesson_id',
            '',
          ), // Use the correct property for course id
          role: [UserRole.STUDENT],
        }));

        const totalMenuList = getMenuList(role, t);
        const updatedMenuItems = totalMenuList.map((section) => {
          if (section.title === 'My courses') {
            return {
              ...section,
              menu: menuItems,
            };
          }
          return section;
        });

        setMenuList(updatedMenuItems);
      } else {
        setMenuList([]);
      }
    };
    getStudentCoursesRoutes();
  }, [role, id, i18n.language]);

  return (
    <div
      className={`sidebar-wrapper ${sideBarToggle ? 'close_icon' : ''}`}
      data-layout={`${sideBarIcon}-svg`}
    >
      <div>
        <LogoWrapper />
        <nav className="sidebar-main">
          <div
            className={`left-arrow ${margin >= 0 ? 'disabled' : ''}`}
            onClick={() => dispatch(scrollToLeft())}
            id="left-arrow"
          >
            <ArrowLeft />
          </div>
          <div id="sidebar-menu" style={{ position: 'inherit', marginLeft: margin + 'px' }}>
            <ul className="sidebar-links custom-scrollbar" id="simple-bar">
              <SimpleBar style={{ width: '68px', height: '350px' }}>
                <li className="back-btn">
                  <Link to={routes.Dashboard.Default}>
                    <Image className="img-fluid" src={dynamicImage(`logo/logo-icon.png`)} alt="" />
                  </Link>
                  <div className="mobile-back text-end">
                    <span>{Back}</span>
                    <i className="fa fa-angle-right ps-2" />
                  </div>
                </li>
                <li
                  className={`pin-title sidebar-main-title ${pinedMenu.length > 0 ? 'show' : ''}`}
                >
                  <div>
                    <h6>{t('global.pinned')}</h6>
                  </div>
                </li>
                {menuList && <MenuList menuList={menuList} />}
              </SimpleBar>
            </ul>
          </div>
          <div
            className={`right-arrow ${margin <= -3300 ? 'disabled' : ''}`}
            onClick={() => dispatch(scrollToRight())}
            id="right-arrow"
          >
            <ArrowRight />
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
